module.exports = __webpack_public_path__ + "img/bg1.e467b1d3.png";